module.exports = __webpack_public_path__ + "img/right-chevron.c6e68a74.svg";